export default __webpack_public_path__ + "static/media/login.c4b38096.jpg";